module.exports = __webpack_public_path__ + "public/images/google-play-badge-tight.faf732f09f86b1a970250f53f846e35c.png";